var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v(_vm._s(option.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }